export default {
  sessionId: state => state.sessionId,
  allAgents: state => state.allAgents,
  agents: state => state.agents,
  deviceToken: state => state.deviceToken,
  answers: state => state.answers,
  errors: state => state.errors
};
